import { TmApiClientError } from '@/core/error/transport/tmApiClientError'
import type { TmTransportHttpErrorCode } from '@/core/error/transport/types'

export class TmApiMethodNotAllowedError extends TmApiClientError {
  public name = 'TmApiMethodNotAllowedError'

  protected override code: TmTransportHttpErrorCode = 405

  protected override isMonitored = false
}
